import { defineMessages } from 'react-intl';

export default defineMessages({
  promoteMfaHeader: {
    id: 'mfa.promote.header',
    defaultMessage: 'Enable two-step verification',
    description: 'Header to promote two-step verification',
  },
  promoteMfaMessageBody: {
    id: 'mfa.promote.message',
    defaultMessage:
      'To keep your account secure, you can enable two-step verification. This adds a second login step for extra protection.',
    description: 'Main message to promote two-step verification',
  },
  promoteMfaLearnMore: {
    id: 'mfa.promote.learn',
    defaultMessage: 'Learn more about two-step verification',
    description: 'Text on link to learn more about two-step verification',
  },
  promoteMfaContinue: {
    id: 'mfa.promote.continue',
    defaultMessage: 'Enable two-step verification',
    description: 'Button text for continue to setup two-step verification',
  },
  promoteMfaDismiss: {
    id: 'mfa.promote.dismiss',
    defaultMessage: 'Continue without two-step verification',
    description: 'Button text for continuing without setting up two-step verification',
  },
});
